import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';

export function noSelectableOptionsBuilder() {
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        All potential options filtered out.
      </Body3>
    </td>
  );
}
